import { createTheme } from "@mui/material/styles";
export const theme = createTheme({
    typography: {
        button: {
            textTransform: "none"
        },
        fontFamily: "Arimo",
        body_header1: {
            lineHeight: 1.6,
            fontSize: 15,
            fontWeight: 500,
            color: "#06b6ad"
        },
        plain_text: {
            fontWeight: 100,
            fontSize: '1rem'
        },
        qlist_text: {
            fontWeight: 100,
            fontSize: '1.2rem',
            fontFamily: 'Century-Gothic'
        },
        bold_text: {
            fontWeight: 'bold',
            fontSize: '1rem'
        },
        logo_text: {
            fontWeight: 'bold'
        },
        h6_bold: {
            fontSize: '1.25rem',
            fontWeight: 'bold'
        },
        h5_bold: {
            fontSize: '1.5rem',
            fontWeight: 'bold'
        },
        h3_bold: {
            fontSize: '3rem',
            fontWeight: 'bold'
        },
        h4_bold: {
            fontSize: '2.125rem',
            fontWeight: 'bold'
        },
        tlrg_footer: {
            fontWeight: 100,
            fontSize: '0.9rem'
        },
    },
    palette: {
        primary: {
            main: "#06b6ad",
            contrastText: "white"
        },
        secondary: {
            main: "#21385e",
            contrastText: "white"
        }
    }
  });
//   #016d7c
